/* ============================================================
   ms-pdp.js — template product.ms-pdp (bố cục DFS). Kế thừa plumbing của ms-product.js:
   0 đơn vị cm|inch · 0b header sticky · 1 plate (layers + 360° Cylindo + Easify→features) · 1c giá theo option Easify
   2 skeleton Easify · 3 dialog · 4 V12 finance popup · 5 badge Judge.me → tab Reviews
   Mới: 6 tabs · 7 dots + swipe + mũi tên · 8 "View all" versions · zoom lightbox.
   ============================================================ */
(function () {
  var root = document.querySelector('[data-ms-pd]');
  if (!root) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── 0. ĐƠN VỊ ── */
  function inch(cm) { return Math.round(cm / 2.54) + '″'; }
  function both(cm, ins) { return '<span class="cm">' + cm + '</span><span class="in">' + ins + '</span>'; }
  function convertCm(el) {
    if (!el) return;
    var t = el.textContent.trim();
    var m = t.match(/^([\d.\s\/–×x-]+?)\s*cm$/);
    if (m) {
      var ins = m[1].split(/([\/–×x-])/).map(function (p) { return /^\s*[\d.]+\s*$/.test(p) ? inch(+p) : ' ' + p + ' '; }).join('').replace(/\s+/g, ' ').trim();
      el.innerHTML = both(t, ins);
      return;
    }
    el.innerHTML = el.innerHTML.replace(/(\d+(?:\.\d+)?)\s*cm\b/g, function (_, n) { return both(n + ' cm', inch(+n)); });
  }
  root.querySelectorAll('.ms-pd__tbl td').forEach(convertCm);
  root.querySelectorAll('.ms-pd__units').forEach(function (u) {
    if (u.nextElementSibling && u.nextElementSibling.querySelector('.in')) u.hidden = false;
  });
  root.addEventListener('click', function (e) {
    var b = e.target.closest('.ms-pd__units button'); if (!b) return;
    root.setAttribute('data-ms-unit', b.dataset.unit);
    root.querySelectorAll('.ms-pd__units button').forEach(function (x) { x.setAttribute('aria-pressed', String(x.dataset.unit === b.dataset.unit)); });
  });

  /* ── 0b. HEADER STICKY → --ms-stick ── */
  function stick() {
    var h = 0;
    document.querySelectorAll('.ms-hdr--bar, .shopify-section-group-header-group').forEach(function (e) {
      if (/sticky|fixed/.test(getComputedStyle(e).position)) h = Math.max(h, e.getBoundingClientRect().bottom);
    });
    root.style.setProperty('--ms-stick', Math.round(h) + 'px');
  }
  stick(); window.addEventListener('resize', stick);

  /* ── 6. TABS ── */
  var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
  var tabsSec = root.querySelector('[data-ms-tabs]');
  function selectTab(id, scroll) {
    tabs.forEach(function (t) {
      var on = t.id === id, p = document.getElementById(t.getAttribute('aria-controls'));
      t.setAttribute('aria-selected', String(on));
      if (p) p.hidden = !on;
    });
    if (scroll && tabsSec) tabsSec.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
  }
  tabs.forEach(function (t) { t.addEventListener('click', function () { selectTab(t.id, false); }); });
  root.querySelectorAll('[data-ms-tab]').forEach(function (b) { b.addEventListener('click', function () { selectTab(b.getAttribute('data-ms-tab'), true); }); });

  /* ── 1. PLATE — layers + thumbs/dots + 360° (Cylindo) + Easify → features ── */
  (function () {
    var box = root.querySelector('[data-ms-plate-box]');
    if (!box) return;
    var code = root.getAttribute('data-cylindo');
    var q = function (s) { return root.querySelector(s); };
    var layers = Array.prototype.slice.call(box.querySelectorAll('[data-ms-media]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-ms-thumb]'));
    var live = q('[data-ms-plate-live]');
    /* như new-360-gallery: công tắc giường mở (Cylindo POSITION, chỉ hiện khi /configuration có OPEN) + vòng cung theo frame 1–32 */
    var bBed = q('[data-ms-bed]'), spinClip = q('[data-ms-spin-clip]'), spinDot = q('[data-ms-spin-dot]');
    function bedVis() { if (bBed) bBed.hidden = !(on && cfg && cfg.POSITION && cfg.POSITION.OPEN); }
    function spin(f) {   // frame 1 = mặt trước = giữa cung; đường cong Q(1,1)(81,41)(161,1): x = 1+160t, y = 1+80t(1-t)
      if (!spinDot || !(f > 0)) return;
      var t = ((f - 1) / 32 + 0.5) % 1;
      spinDot.setAttribute('cx', 1 + 160 * t); spinDot.setAttribute('cy', 1 + 80 * t * (1 - t)); spinClip.setAttribute('width', 5 + 160 * t);
    }
    /* mobile: track scroll-snap → kéo bằng ngón tay; showMedia cuộn track, cuộn tay cập nhật cur + dots */
    var track = box.querySelector('[data-ms-track]'), trackT;
    function slid() { return !!track && track.scrollWidth > track.clientWidth + 1; }
    var viewer = null, features = {}, ok = !!code, on = false, painted = false, cur = 0;
    /* mobile / save-data: không preload viewer lúc idle (32 frame ≈ 0.8MB), mount khi bấm 360° hoặc commit màu */
    var lazy = !matchMedia('(min-width:1024px)').matches || !!(navigator.connection && navigator.connection.saveData), pickKey = null;
    /* cfg = option Cylindo có render ({UPHOLSTERY:{'ASTON PINE':1}}), từ /configuration. Màu Easify không có trong đó → về ảnh featured */
    var cfg = null, miss = false, dflt = {};
    /* màu không có trong Cylindo → thay bằng option mặc định (isDefault) để 360° vẫn mở được */
    function safe(f) {
      var o = {}; Object.keys(f).forEach(function (k) { o[k] = cfg && cfg[k] && !cfg[k][f[k]] ? dflt[k] : f[k]; if (!o[k]) delete o[k]; }); return o;
    }
    function renderable(f) {
      return !cfg || Object.keys(f).every(function (k) { return !cfg[k] || cfg[k][f[k]]; });
    }
    function check(commit) {
      miss = !renderable(features);
      if (miss && (commit || on)) { setMode(false); showMedia(0); }
    }

    function pauseVideos() { layers.forEach(function (l) { var v = l.querySelector('video'); if (v) v.pause(); }); }
    function markThumbs() {
      thumbs.forEach(function (t) {
        var k = t.getAttribute('data-ms-thumb');
        t.setAttribute('aria-pressed', String(on ? k === '360' : k === String(cur)));
      });
    }
    function showMedia(i) {
      if (!layers.length) return;
      cur = (i + layers.length) % layers.length;
      layers.forEach(function (l, j) { l.hidden = j !== cur; });
      if (slid()) { var x = cur * track.clientWidth; if (Math.abs(track.scrollLeft - x) > 2) track.scrollTo({ left: x, behavior: reduce ? 'auto' : 'smooth' }); }
      pauseVideos();
      markThumbs();
      var th = root.querySelector('.ms-pd__thumbs [data-ms-thumb="' + cur + '"]');
      /* chỉ cuộn dải thumb (không cuộn trang — scrollIntoView kéo cả trang khi thumb nằm ngoài màn hình) */
      var tc = th && th.parentElement;
      if (tc) { var a = th.getBoundingClientRect(), r = tc.getBoundingClientRect(); tc.scrollTo({ left: tc.scrollLeft + a.left - r.left - (r.width - a.width) / 2, top: tc.scrollTop + a.top - r.top - (r.height - a.height) / 2, behavior: reduce ? 'auto' : 'smooth' }); }
    }
    function setMode(next) {
      on = next;
      box.classList.toggle('is-360', on);
      root.querySelectorAll('[data-ms-needs360]').forEach(function (b) { b.hidden = !on; });
      bedVis();
      if (on) pauseVideos();
      if (live) live.textContent = live.getAttribute(on ? 'data-live-360' : 'data-live-photo');
      markThumbs();
    }
    function applyFeatures() {
      if (!viewer) return;
      var apply = function () { viewer.features = Object.assign({}, viewer.features || {}, safe(features)); };
      customElements.get('cylindo-viewer') ? apply() : customElements.whenDefined('cylindo-viewer').then(apply);
    }
    /* frame <img> nằm trong shadow root LỒNG (cylindo-three-sixty) → tìm sâu; frame lấy từ cache không sinh resource entry mới */
    function drawn(r) {
      if (Array.prototype.some.call(r.querySelectorAll('img'), function (i) { return i.complete && i.naturalWidth > 0; })) return true;
      return Array.prototype.some.call(r.querySelectorAll('*'), function (e) { return e.shadowRoot && drawn(e.shadowRoot); });
    }
    function whenPainted(cb) {
      var t0 = Date.now();
      (function poll() {
        var sr = viewer && viewer.shadowRoot;
        var im = sr && drawn(sr);
        var got = performance.getEntriesByType('resource').some(function (r) { return r.name.indexOf('cylindo') > -1 && r.name.indexOf('/frames/') > -1 && r.name.indexOf('.webp') > -1 && r.responseEnd > 0 && performance.timeOrigin + r.startTime >= t0 - 50; });
        /* script Cylindo tải chậm (mạng yếu/blocker) → chưa định nghĩa thì đừng bật 360 rỗng, chờ tiếp (tối đa 30s, cùng mốc giveUp) */
        if (im || got || sr && sr.querySelector('canvas') || Date.now() - t0 > 2500 && customElements.get('cylindo-viewer')) { painted = true; return cb(); }
        if (Date.now() - t0 < 30000) setTimeout(poll, 100);
      })();
    }
    function ensureViewer() {
      if (!ok || viewer) return;
      viewer = document.createElement('cylindo-viewer');
      viewer.setAttribute('customer-id', '9633');
      viewer.setAttribute('code', code);
      viewer.setAttribute('data-ms-viewer', '');
      /* iPhone không có Fullscreen API cho phần tử → Cylindo tự phủ .root position:fixed z-index:250, bị header sticky (z 510) che mất nút X → nâng host lên khi đang phủ.
         Safari iOS: nút của Cylindo nuốt touch nên không có 'click' → theo dõi thêm touchend/pointerup + MutationObserver trên shadow root */
      var fsCheck = function () { setTimeout(function () { var r = viewer && viewer.shadowRoot && viewer.shadowRoot.querySelector('.root'); if (!r) return; var on = getComputedStyle(r).position === 'fixed'; if (on === viewer.classList.contains('is-fs')) return; viewer.classList.toggle('is-fs', on);
        /* fullscreen chỉ hiện .root của Cylindo → dòng bed open chuyển vào slot overlay lúc phủ, thoát thì trả về */
        var br = q('.ms-pdp__bedrow'), foot = q('.ms-pd__plate-foot'), ov = viewer.querySelector('.ms-pdp__ov');
        if (br && foot && ov) on ? ov.appendChild(br) : foot.insertBefore(br, foot.firstChild);
        /* lúc thoát Cylindo đo host khi còn phủ màn hình → ghi width:390px inline lên .root (nút góc phải lệch ra ngoài khung) → xoá */
        if (!on) { r.style.width = r.style.height = ''; window.dispatchEvent(new Event('resize')); } }, 50); };
      ['click', 'touchend', 'pointerup'].forEach(function (t) { viewer.addEventListener(t, fsCheck, true); });
      customElements.whenDefined('cylindo-viewer').then(function () { if (viewer && viewer.shadowRoot) new MutationObserver(fsCheck).observe(viewer.shadowRoot, { attributes: true, subtree: true, attributeFilter: ['class', 'style'] }); });
      if (customElements.get('cylindo-viewer')) viewer.features = safe(features);   // trước khi gắn DOM → không tải bộ màu mặc định
      viewer.addEventListener('frame-change', function () { spin(viewer.frame); });
      /* slot "overlay" nằm trong .root → vòng cung vẫn hiện khi fullscreen */
      var ov = document.createElement('div'), sp = q('.ms-pdp__spin');
      ov.slot = 'overlay'; ov.className = 'ms-pdp__ov';
      if (sp) ov.appendChild(sp);
      viewer.appendChild(ov);
      box.insertBefore(viewer, box.querySelector('.ms-pdp__360'));   // trên các lớp media, dưới 2 nút nổi
      applyFeatures();
      whenPainted(function () {});
      setTimeout(function () { if (viewer && !customElements.get('cylindo-viewer')) giveUp(); }, 30000);   // 8s quá gắt: iPhone mạng yếu mất nút 360 vĩnh viễn
    }
    function activate(user) {
      /* màu ngoài Cylindo: tự động (chọn màu/tải trang) thì giữ ảnh chính; người dùng bấm 360° → mở 360° màu mặc định (safe) */
      if (!ok || (miss && !user)) return;
      ensureViewer();
      applyFeatures();
      if (on || painted) { setMode(true); return; }
      whenPainted(function () { if (ok) setMode(true); });
    }
    function giveUp() {
      ok = false;
      if (viewer) { viewer.remove(); viewer = null; }
      setMode(false);
      root.querySelectorAll('[data-ms-thumb="360"], [data-ms-needs360]').forEach(function (b) { b.remove(); });
      if (live) live.remove();
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var k = t.getAttribute('data-ms-thumb');
        if (k === '360') { if (on) { setMode(false); showMedia(cur); } else { activate(true); } return; }
        setMode(false); showMedia(+k);
      });
    });
    root.querySelectorAll('[data-ms-step]').forEach(function (b) { b.addEventListener('click', function () { setMode(false); showMedia(cur + (+b.getAttribute('data-ms-step'))); }); });
    /* swatch variant (1c) → nhảy tới ảnh của variant */
    root.addEventListener('ms:media', function (e) { if (e.detail >= 0 && e.detail < layers.length) { setMode(false); showMedia(e.detail); } });
    if (track) track.addEventListener('scroll', function () {
      clearTimeout(trackT);
      trackT = setTimeout(function () {
        if (!slid()) return;
        var i = Math.round(track.scrollLeft / track.clientWidth);
        if (i !== cur && layers[i]) { cur = i; layers.forEach(function (l, j) { l.hidden = j !== cur; }); pauseVideos(); markThumbs(); }
      }, 60);
    }, { passive: true });
    /* 7. swipe trên ảnh khi KHÔNG có track cuộn (tablet ≥1024 cảm ứng); không trong chế độ 360° — Cylindo cần kéo để xoay */
    var sx = null, sy = null;
    box.addEventListener('pointerdown', function (e) { if (on || e.pointerType === 'mouse' || slid()) { sx = null; return; } sx = e.clientX; sy = e.clientY; }, { passive: true });
    box.addEventListener('pointerup', function (e) {
      if (sx === null) return;
      var dx = e.clientX - sx, dy = e.clientY - sy; sx = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) showMedia(cur + (dx < 0 ? 1 : -1));
    }, { passive: true });

    var bFull = q('[data-ms-full]'); if (bFull) bFull.addEventListener('click', function () { if (viewer) viewer.fullscreen = true; });
    if (bBed) bBed.addEventListener('click', function () {
      var o = bBed.getAttribute('aria-checked') !== 'true';
      bBed.setAttribute('aria-checked', String(o));
      features = Object.assign({}, features, { POSITION: o ? 'OPEN' : 'CLOSED' });
      applyFeatures();
    });
    var bAr = q('[data-ms-ar]'); if (bAr) bAr.addEventListener('click', function () { if (viewer) viewer.ar = true; });
    var bShare = q('[data-ms-share]'); if (bShare) bShare.addEventListener('click', function () {
      var lab = q('[data-ms-share-lab]');
      var p = navigator.clipboard ? navigator.clipboard.writeText(location.href) : Promise.reject();
      p.then(function () { lab.textContent = 'Link copied'; }, function () { lab.textContent = 'Copy failed'; });
      setTimeout(function () { lab.textContent = 'Share'; }, 2000);
    });

    /* zoom: ảnh của lớp đang hiện (data-full) */
    var zoomBtn = q('[data-ms-dialog="ms-pdp-dlg-zoom"]'), zoomImg = document.querySelector('[data-ms-zoom-img]');
    if (zoomBtn && zoomImg) zoomBtn.addEventListener('mousedown', prime), zoomBtn.addEventListener('touchstart', prime, { passive: true }), zoomBtn.addEventListener('focus', prime);
    function prime() {
      var l = layers[cur]; if (!l) return;
      var src = l.getAttribute('data-full') || (l.querySelector('img') && l.querySelector('img').currentSrc);
      if (src && zoomImg.getAttribute('src') !== src) zoomImg.setAttribute('src', src);
    }
    if (zoomBtn) zoomBtn.hidden = !(layers[0] && layers[0].getAttribute('data-full'));

    /* Easify → Cylindo */
    function featureFor(label) {
      label = label.toLowerCase();
      if (/frame/.test(label)) return 'FRAME';
      if (/leg/.test(label)) return 'LEG FINISH';
      if (/orientation|side/.test(label)) return 'ORIENTATION';
      if (/colou?r|fabric|upholster/.test(label)) return 'UPHOLSTERY';
      return null;
    }
    function clean(v) { return v.replace(/fabric\s*/i, '').replace(/\[\s*\+\s*£?\d+(\.\d{2})?\s*\]/gi, '').trim().toUpperCase(); }
    function scan() {
      var changed = false;
      root.querySelectorAll('.po-field-root, .tpo_option-label').forEach(function (f) {
        var labEl = f.querySelector('.po-label-label, .form__label');
        var key = labEl && featureFor(labEl.textContent || ''); if (!key) return;
        var valEl = f.querySelector('.po-productList-style1Selected, .po-select-selectedValue, .tpo_selected-option');
        if (!valEl) return;
        var c = valEl.cloneNode(true); Array.prototype.forEach.call(c.querySelectorAll('*'), function (x) { x.remove(); });
        var v = clean(c.textContent || ''); if (!v || features[key] === v) return;
        features[key] = v; changed = true;
      });
      if (!changed) return;
      check(true); activate();
      if (lazy && primed) reveal();
    }
    var form = document.getElementById('product_form_ms-pdp'), primed = false;
    if (form) {
      new MutationObserver(scan).observe(form, { childList: true, subtree: true, characterData: true }); scan(); primed = true;
      form.addEventListener('click', function (e) {
        var f = e.target.closest('.po-field-root, .tpo_option-label'); if (!f) return;
        var lab = f.querySelector('.po-label-label, .form__label'); pickKey = lab ? featureFor(lab.textContent || '') : null;
        if (pickKey && ok) warm();
        if (!lazy) activate();
      });
    }
    var gal = root.querySelector('.ms-pdp__gal') || box;
    var revealT = 0;
    /* TẮT 2026-10-18 (yêu cầu user): chọn màu không cuộn trang lên gallery nữa. Bật lại = xoá dòng return */
    function reveal() {
      return;
      if (Date.now() - revealT < 1000) return; revealT = Date.now();
      stick();
      var go = function () { gal.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' }); };
      go();
      setTimeout(function () { if (Math.abs(gal.getBoundingClientRect().top - parseFloat(getComputedStyle(gal).scrollMarginTop)) > 40) go(); }, 800);
    }
    function whenPickerClosed(cb, t0) {
      t0 = t0 || Date.now();
      if (!document.querySelector('label.po-productListItem-itemContainer, dialog[class*="po-dialog"][open]') || Date.now() - t0 > 2000) return cb();
      setTimeout(function () { whenPickerClosed(cb, t0); }, 100);
    }
    document.addEventListener('click', function (e) {
      if (!e.target.closest('[class*="po-productListItem"], [class*="po-optionItem"], [class*="po-select-option"], .tpo_option-type-selection')) return;
      /* biết màu ngay lúc tap (nhãn swatch) → mount/đổi viewer luôn, sau lưng picker, không chờ picker đóng (~350ms); scan() sau đó sửa nếu lệch */
      var it = e.target.closest(SW), v = it && cfg && pickKey && valOf(it);
      if (v && features[pickKey] !== v) { features = Object.assign({}, features); features[pickKey] = v; check(true); }
      if (!lazy || v) activate();
      setTimeout(function () { whenPickerClosed(function () { scan(); reveal(); }); }, 150);
    }, true);

    /* mở picker → prefetch frame 1 của MỌI màu có render (21 × ~17KB): CDN Cylindo render màu "lạnh" mất ~0.6–1s/frame,
       làm trước lúc khách còn đang xem → tap = cache-hit (CDN max-age 1y). Size 768 = frame viewer thực sự vẽ (đo cả mobile DPR3 lẫn desktop; request 512 chỉ là <link preload> phụ của viewer) */
    var seen = {}, SW = '[class*="po-productListItem-itemContainer"]', FIRST = '768';
    /* viewer chỉ tải chunk three-sixty-<hash>.js lúc mount (~250ms trên 4G trước khi xin frame) → modulepreload sẵn; tên có hash nên đọc từ index.mjs (đã cache) */
    var chunked = false;
    function preloadChunk() {
      if (chunked) return; chunked = true;
      var base = 'https://viewer-cdn.cylindo.com/v1/index.mjs';
      fetch(base).then(function (r) { return r.text(); }).then(function (t) {
        var m = /three-sixty-[A-Za-z0-9_-]+[.]js/.exec(t); if (!m) return;
        var l = document.createElement('link'); l.rel = 'modulepreload'; l.href = new URL(m[0], base).href; document.head.appendChild(l);
      }).catch(function () {});
    }
    function warm(t0) {
      preloadChunk();
      t0 = t0 || Date.now();
      var items = document.querySelectorAll(SW);
      if (items.length) return Array.prototype.forEach.call(items, prefetch);
      if (Date.now() - t0 < 3000) setTimeout(function () { warm(t0); }, 150);
    }
    function valOf(item) {
      var lab = item.querySelector('.po-optionItemLabel-label') || item;
      return clean((lab.textContent || '').replace(/[(].*?[)]/g, ''));
    }
    function prefetch(item) {
      if (!ok || !pickKey || !cfg) return;
      var val = valOf(item); if (!val) return;
      var f = Object.assign({}, viewer && viewer.features || {}, features); f[pickKey] = val;
      if (!renderable(f)) return;
      var url = 'https://content.cylindo.com/api/v2/9633/products/' + encodeURIComponent(code) + '/frames/1/' + encodeURIComponent(code) + '.webp?size=' + FIRST +
        Object.keys(f).map(function (k) { return '&feature=' + encodeURIComponent(k) + ':' + encodeURIComponent(f[k]); }).join('');
      if (seen[url]) return; seen[url] = 1;
      var im = new Image(); im.fetchPriority = 'low'; im.src = url;
    }

    if (ok) {
      fetch('https://content.cylindo.com/api/v2/9633/products/' + encodeURIComponent(code) + '/configuration')
        .then(function (r) { if (!r.ok) throw r.status; return r.json(); })
        .then(function (c) {
          if (!c.enabled) return giveUp();
          cfg = {};
          (c.features || []).forEach(function (f) { cfg[f.code] = {}; f.options.forEach(function (o) { cfg[f.code][o.code] = 1; if (o.isDefault) dflt[f.code] = o.code; }); if (!dflt[f.code] && f.options[0]) dflt[f.code] = f.options[0].code; });
          check(false); bedVis();
          if (!lazy) schedulePreload();
        }, function (e) { if (e === 404) return giveUp(); if (!lazy) schedulePreload(); });
    }
    function schedulePreload() {
      var go = function () { ('requestIdleCallback' in window) ? requestIdleCallback(ensureViewer, { timeout: 3000 }) : setTimeout(ensureViewer, 1200); };
      document.readyState === 'complete' ? go() : window.addEventListener('load', go, { once: true });
    }
    if (!layers.length) activate(true);
  })();

  /* ── 1c. GIÁ THEO OPTION EASIFY (.po-priceSummary-price → delta vào mọi [data-ms-price]) ── */
  (function () {
    var form = document.getElementById('product_form_ms-pdp'); if (!form) return;
    var els = root.querySelectorAll('[data-ms-price]');
    var base = +root.getAttribute('data-price'), last = base;
    var sym = (els[0] ? els[0].textContent : '£').replace(/[\d.,\s]/g, '') || '£';
    function money(pence) { return sym + (pence / 100).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
    function update() {
      var sum = form.querySelector('.po-priceSummary-price'), total = base;
      if (sum) {
        var n = parseFloat(sum.textContent.replace(/[^\d.]/g, ''));
        if (isFinite(n)) total = Math.round(n * 100);
      }
      if (total === last) return;
      last = total;
      var delta = total - base;
      els.forEach(function (el) { el.textContent = money(+el.getAttribute('data-ms-price') + delta); });
      document.dispatchEvent(new CustomEvent('ms:price', { detail: { total: total / 100 } }));
    }
    document.addEventListener('easify:options-change', function () { setTimeout(update, 50); });
    new MutationObserver(update).observe(form, { childList: true, subtree: true, characterData: true });
    /* fallback native variant select (không Easify) */
    var sel = form.querySelector('[data-ms-variant]');
    if (sel) {
      var hid = form.querySelector('input[name="id"]'); if (hid) hid.remove();
      /* tồn kho thấp theo variant đang chọn (map render từ Liquid; Easify không có select này → giữ số server render) */
      var stock = root.querySelector('[data-ms-stock]'), mapEl = root.querySelector('[data-ms-stock-map]');
      var vmap = mapEl ? JSON.parse(mapEl.textContent) : {};
      var now = root.querySelector('.ms-pdp__now'), meta = root.querySelector('.ms-pdp__meta'), eyebrow = root.querySelector('.ms-pdp__eyebrow');
      sel.addEventListener('change', function () {
        var v = vmap[sel.value]; if (!v) return;
        if (stock) {
          var q = v.q || 0, low = q > 0 && q < 5;
          stock.hidden = !low;
          if (low) { stock.querySelector('[data-ms-stock-n]').textContent = q; stock.querySelector('[data-ms-stock-bar]').style.width = q * 20 + '%'; }
        }
        /* giá theo variant: đổi base cho 1c + attr data-ms-price, rồi bắn ms:price (coupon card, V12 đọc .ms-pdp__now) */
        base = last = v.p; root.setAttribute('data-price', v.p);
        if (now) { now.setAttribute('data-ms-price', v.p); now.textContent = money(v.p); }
        /* shortcut: khối Save/Was chỉ có khi variant đầu đang sale → variant khác chỉ ẩn/hiện + cập nhật nó, không tự tạo; nâng cấp nếu có sp variant đầu không sale mà variant khác sale */
        var sale = v.c > v.p;
        if (now) now.classList.toggle('is-sale', sale && !!meta);
        if (meta) {
          meta.hidden = !sale;
          if (sale) {
            meta.querySelector('b').textContent = 'Save ' + money(v.c - v.p).replace(/\.00$/, '');
            var was = meta.querySelector('[data-ms-price]'); was.setAttribute('data-ms-price', v.c); was.textContent = money(v.c);
          }
        }
        if (eyebrow) eyebrow.hidden = !sale;
        document.dispatchEvent(new CustomEvent('ms:price', { detail: { total: v.p / 100 } }));
        /* variant hết hàng (chọn được qua swatch) → khoá nút mua */
        var atc = form.querySelector('.ms-pd__atc'), so = sel.selectedOptions[0] && sel.selectedOptions[0].disabled;
        if (atc) { atc.disabled = so; var tn = atc.lastChild; if (tn && tn.nodeType === 3) tn.textContent = so ? 'Sold out' : 'Add to Basket'; }
      });

      /* swatch / pill (setting variant_style = buttons): chọn → tìm variant khớp → set select + change */
      var opts = root.querySelector('[data-ms-opts]'), voEl = root.querySelector('[data-ms-vopts]');
      if (opts && voEl) {
        var vs = JSON.parse(voEl.textContent), fields = [].slice.call(opts.querySelectorAll('[data-ms-opt]'));
        var picked = function () { return fields.map(function (f) { var b = f.querySelector('[aria-pressed="true"]'); return b ? b.getAttribute('data-v') : null; }); };
        var match = function (p) { for (var i = 0; i < vs.length; i++) if (vs[i].o.every(function (x, j) { return x === p[j]; })) return vs[i]; return null; };
        var paint = function () {
          var p = picked();
          fields.forEach(function (f, i) {
            f.querySelector('[data-ms-opt-val]').textContent = p[i] || '';
            f.querySelectorAll('[data-v]').forEach(function (b) {
              var val = b.getAttribute('data-v'), t = p.slice(); t[i] = val; var v = match(t);
              b.classList.toggle('is-na', !v || !v.a);
              /* disable chỉ khi giá trị hết hàng ở MỌI tổ hợp — hết hàng riêng tổ hợp hiện tại vẫn bấm được (tự nhảy sang tổ hợp còn hàng) */
              b.disabled = !vs.some(function (x) { return x.o[i] === val && x.a; });
            });
          });
        };
        opts.addEventListener('click', function (e) {
          var b = e.target.closest('[data-v]'); if (!b) return;
          var f = b.closest('[data-ms-opt]'), i = fields.indexOf(f), val = b.getAttribute('data-v');
          f.querySelectorAll('[data-v]').forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
          var v = match(picked());
          /* tổ hợp không tồn tại → lấy variant có giá trị vừa bấm, ưu tiên còn hàng, rồi đồng bộ các option khác theo nó */
          if (!v) {
            v = vs.filter(function (x) { return x.o[i] === val && x.a; })[0] || vs.filter(function (x) { return x.o[i] === val; })[0];
            if (!v) return;
            fields.forEach(function (g, j) { g.querySelectorAll('[data-v]').forEach(function (x) { x.setAttribute('aria-pressed', String(x.getAttribute('data-v') === v.o[j])); }); });
          }
          sel.value = String(v.id);
          sel.dispatchEvent(new Event('change'));
          paint();
          if (v.m >= 0) root.dispatchEvent(new CustomEvent('ms:media', { detail: v.m }));
        });
        paint();
      }
    }
  })();

  /* ── 1d. COUPON CARD — giá "with code" tính lại theo ms:price (1c bắn sau mỗi lần đổi giá), nút copy mã ── */
  (function () {
    var cp = root.querySelector('[data-ms-coupon]'); if (!cp) return;
    var after = cp.querySelector('[data-ms-cp-after]'), save = cp.querySelector('[data-ms-cp-save]');
    var now = root.querySelector('.ms-pdp__now');
    var sym = (now ? now.textContent : '£').replace(/[\d.,\s]/g, '') || '£';
    function money(pence) { return sym + (pence / 100).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
    function calc(pence) {
      var pct = +cp.getAttribute('data-pct'), a = Math.round(pence * (100 - pct) / 100);
      after.textContent = money(a); save.textContent = money(pence - a);
    }
    document.addEventListener('ms:price', function (e) { if (e.detail && isFinite(e.detail.total)) calc(Math.round(e.detail.total * 100)); });
    var btn = cp.querySelector('[data-ms-cp-copy]'), label = btn.querySelector('span'), code = cp.getAttribute('data-code'), t;
    function done() {
      label.textContent = 'Copied'; btn.classList.add('is-copied'); clearTimeout(t);
      t = setTimeout(function () { label.textContent = 'Copy code'; btn.classList.remove('is-copied'); }, 2000);
    }
    /* không có clipboard API (iOS cũ, http): chọn text mã rồi execCommand; vẫn thất bại thì giữ "Copy code", mã đang được bôi đen để khách tự copy */
    function fallback() {
      var el = cp.querySelector('code'), r = document.createRange(), s = window.getSelection();
      r.selectNodeContents(el); s.removeAllRanges(); s.addRange(r);
      try { if (document.execCommand('copy')) done(); } catch (_) {}
    }
    btn.addEventListener('click', function () {
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(done, fallback); else fallback();
    });
    /* đếm ngược tới ends_at (epoch giây, render khi entry có Ends at); hết giờ → ẩn card. starts_at tương lai chỉ gặp trên trang cache cũ → ẩn luôn */
    var timer = cp.querySelector('[data-ms-cp-ends]'), startsAt = (+cp.getAttribute('data-ms-cp-starts') || 0) * 1000, iv = 0;
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var now = Date.now();
      if (startsAt && now < startsAt) { cp.hidden = true; return; }
      if (!timer) { cp.hidden = false; return; }
      var left = Math.floor((+timer.getAttribute('data-ms-cp-ends') * 1000 - now) / 1000);
      if (!(left > 0)) { cp.hidden = true; clearInterval(iv); return; }
      cp.hidden = false;
      var d = Math.floor(left / 86400), h = Math.floor(left % 86400 / 3600), m = Math.floor(left % 3600 / 60), s = left % 60;
      timer.querySelector('[data-ms-cp-left]').textContent = d > 0 ? d + 'd ' + pad(h) + 'h ' + pad(m) + 'm' : pad(h) + 'h ' + pad(m) + 'm ' + pad(s) + 's';
    }
    if (timer || startsAt) { iv = setInterval(tick, 1000); tick(); }
  })();

  /* ── 1e. POSTCODE CHECKER — hỏi app Postcode Shipping qua app proxy <data-proxy>/quote (country, postal_code, price pence, grams, quantity)
     → rates[] {service_name, description, total_price pence}. Chọn rate theo tầng: 0 = rate không nhắc Upper/1–3/4–6; 1 (và lift) = tên có "1–3"; 2 = "4–6";
     không có rate riêng tầng → rate không nhắc tầng nào (vd "Isle Of Weight", "Green Zone – Free Delivery Over £250"); nhiều zone trùng → rẻ nhất. Ngưỡng free/giảm giá theo giá trị đơn: dò từ app (threshold()), không hardcode.
     rates rỗng → không giao tới khu vực đó (merchant xác nhận 2026-10-22: HS/KW/BT/IM/GY/JE/ZE không giao). price = giá sản phẩm đang xem (.ms-pdp__now, cập nhật qua ms:price của 1c) — giả định đơn chỉ có sản phẩm này. ── */
  (function () {
    var box = root.querySelector('[data-ms-pc]'); if (!box) return;
    var form = box.querySelector('form'), input = form.querySelector('input'), floor = form.querySelector('select'), btn = form.querySelector('button'), out = box.querySelector('[data-ms-pc-out]');
    var phone = box.getAttribute('data-phone') || '', proxy = (box.getAttribute('data-proxy') || '/apps/postcode-shipping').replace(/\/$/, ''), grams = +box.getAttribute('data-grams') || 1000;
    var FLOORS = { '0': 'ground floor', '1': 'floors 1–3', '2': 'floors 4–6', lift: 'above floor 6 with a lift', nolift: 'above floor 6 without a lift' };
    var RX = { '1': /\b1\s*[–-]\s*3\b/, '2': /\b4\s*[–-]\s*6\b/ }, FLOORWORDS = /upper|floors?\s*\d|\d\s*[–-]\s*\d\s*floors?/i;
    var call = phone ? ' Please <a href="tel:' + phone.replace(/\s/g, '') + '">call ' + phone.replace(/[&<>"]/g, '') + '</a>.' : ' Please contact us.';
    var now = root.querySelector('.ms-pdp__now'), total = NaN, last = null, ctrl = null, btnLabel = btn.textContent;
    function readTotal() { var t = (now ? now.textContent : '').replace(/[^\d.]/g, ''); total = t ? +t : NaN; }
    /* "sw1a 1aa" → {oc:'SW1A', compact:'SW1A1AA'}; null nếu không phải postcode UK ĐỦ (app cần cả inward: outward-only → rates rỗng) */
    function parse(v) { var m = (v || '').toUpperCase().replace(/[^A-Z0-9]/g, '').match(/^([A-Z]{1,2}\d[A-Z\d]?)(\d[A-Z]{2})$/); return m ? { oc: m[1], compact: m[0] } : null; }
    function esc(s) { return String(s).replace(/[&<>"]/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[ch]; }); }
    function show(html, err) { out.innerHTML = html; out.hidden = false; out.classList.toggle('is-err', !!err); }
    function money(p) { return '£' + (p / 100).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/\.00$/, ''); }
    function choose(rates, f) {
      var k = f === 'lift' ? '1' : f, c;
      if (k === '0') c = rates.filter(function (r) { return !FLOORWORDS.test(r.service_name); });
      else { c = rates.filter(function (r) { return RX[k].test(r.service_name); }); if (!c.length) c = rates.filter(function (r) { return !/ground|upper|floor/i.test(r.service_name); }); }
      return c.sort(function (a, b) { return a.total_price - b.total_price; })[0] || null;
    }
    /* Ngưỡng giá trị đơn (free/giảm giá tầng trệt): app không lộ rule, chỉ có /quote → dò bằng giá 1p và £10k, rồi tìm mốc £ nhỏ nhất
       mà giá tầng trệt rẻ hơn (nhị phân trên STEPS, kiểm c-1, chỉ dò mịn khi mốc không tròn; ~8 request). Cache 24h theo postcode (ms:pct:*).
       test(c) hỏi giá c*100+1 pence vì rule của app là "over £c" (đúng £250.00 app trả rỗng). */
    var STEPS = [100, 150, 200, 250, 300, 400, 500, 600, 750, 800, 1000, 1250, 1500, 2000, 3000, 5000];
    function groundAt(pc, pence) {
      return fetch(proxy + '/quote?country=GB&postal_code=' + pc.compact + '&price=' + pence + '&grams=' + grams + '&quantity=1&currency=GBP', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (j) { var g = choose(j && Array.isArray(j.rates) ? j.rates : [], '0'); return g ? g.total_price : null; });
    }
    /* mốc nguyên nhỏ nhất trong (lo, hi] mà test đúng; lo đã biết sai, hi đã biết đúng */
    function smallest(lo, hi, test) {
      if (hi - lo <= 1) return Promise.resolve(hi);
      var m = (lo + hi) >> 1;
      return test(m).then(function (ok) { return ok ? smallest(lo, m, test) : smallest(m, hi, test); });
    }
    function threshold(pc) {
      var key = 'ms:pct:' + pc.compact, hit = null;
      try { hit = JSON.parse(localStorage.getItem(key) || 'null'); } catch (_) {}
      if (hit && Date.now() - hit.ts < 864e5) return Promise.resolve(hit);
      var res = { ts: Date.now() };
      return Promise.all([groundAt(pc, 1), groundAt(pc, 1e6)]).then(function (p) {
        var low = p[0], high = p[1];
        if (low == null || high == null || high >= low) return res;
        res.low = low; res.high = high;
        var test = function (c) { return groundAt(pc, c * 100 + 1).then(function (v) { return v != null && v < low; }); };
        return smallest(-1, STEPS.length, function (i) { return test(STEPS[i]); }).then(function (i) {
          if (i === STEPS.length) return smallest(STEPS[i - 1], 10000, test);
          var c = STEPS[i], prev = i ? STEPS[i - 1] : 0;
          return test(c - 1).then(function (ok) { return ok ? smallest(prev, c - 1, test) : c; });
        }).then(function (over) { res.over = over; return res; });
      }).then(function (r) { try { localStorage.setItem(key, JSON.stringify(r)); } catch (_) {} return r; });
    }
    var seq = 0;
    function render(pc, f, rates) {
      var where = '<b>' + pc.oc + '</b>, ' + FLOORS[f];
      if (!rates.length) { show('<p>Sorry, we do not deliver to <b>' + pc.oc + '</b> at the moment.</p>', true); return; }
      if (f === 'nolift') { show('<p>Delivery to ' + where + ': please contact us before ordering.' + call + '</p>'); return; }
      var r = choose(rates, f);
      if (!r) { show('<p>Delivery to ' + where + ' is not available.' + call + '</p>', true); return; }
      var head = r.total_price ? 'Delivery to ' + where + ': <b>' + money(r.total_price) + '</b>' : '<b>Free</b> delivery to ' + where;
      var basis = isFinite(total) ? '<small>Based on this product\'s price of £' + total.toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '; the final charge depends on your order value.</small>' : '';
      var lift = f === 'lift' ? '<small>At checkout choose <b>Upper Floor Delivery (1–3 Floors)</b> and add an order note that the property is above the 6th floor.</small>' : '';
      var desc = r.description && r.description !== r.service_name ? '<small>' + esc(r.description) + '</small>' : '';
      show('<p>' + head + '</p>' + basis + lift + desc);
      var my = ++seq;
      threshold(pc).then(function (t) {
        if (my !== seq || out.hidden || t.over == null) return;
        var line = t.high ? 'Ground-floor delivery is <b>' + money(t.high) + '</b> on orders over £' + t.over.toLocaleString('en-GB') + ' (otherwise ' + money(t.low) + ').'
                          : '<b>Free</b> ground-floor delivery on orders over £' + t.over.toLocaleString('en-GB') + ' (otherwise ' + money(t.low) + ').';
        out.insertAdjacentHTML('beforeend', '<small data-ms-pc-th>' + line + '</small>');
      }).catch(function () {});
    }
    function check(v, f, quiet) {
      var pc = parse(v);
      if (!pc) { if (!quiet) show('<p>Please enter your full UK postcode, e.g. <b>HX1 5QH</b>.</p>', true); return; }
      if (!FLOORS[f]) { if (!quiet) show('<p>Please choose a delivery floor.</p>', true); return; }
      try { localStorage.setItem('ms:pc', v.trim().toUpperCase()); localStorage.setItem('ms:pcf', f); } catch (_) {}
      last = { v: v, f: f };
      if (ctrl) ctrl.abort();
      ctrl = typeof AbortController === 'function' ? new AbortController() : null;
      btn.disabled = true; btn.textContent = 'Checking…';
      var q = 'country=GB&postal_code=' + pc.compact + '&price=' + Math.round((isFinite(total) ? total : 0) * 100) + '&grams=' + grams + '&quantity=1&currency=GBP';
      fetch(proxy + '/quote?' + q, { headers: { Accept: 'application/json' }, signal: ctrl ? ctrl.signal : undefined })
        .then(function (r) { return r.json(); })
        .then(function (j) {
          if (j && j.errors) { show('<p>Please enter your full UK postcode, e.g. <b>HX1 5QH</b>.</p>', true); return; }
          render(pc, f, j && Array.isArray(j.rates) ? j.rates : []);
        })
        .catch(function (e) { if (!(e && e.name === 'AbortError')) show('<p>Sorry, we couldn\'t check delivery just now.' + call + '</p>', true); })
        .then(function () { btn.disabled = false; btn.textContent = btnLabel; });
    }
    form.addEventListener('submit', function (e) { e.preventDefault(); check(input.value, floor.value); });
    readTotal();
    document.addEventListener('ms:price', function (e) { if (e.detail && isFinite(e.detail.total)) { total = +e.detail.total; if (last && !out.hidden) check(last.v, last.f, true); } });
    /* postcode + tầng nhớ qua localStorage: PDP sau tự điền + hiện kết quả */
    var sv = '', sf = ''; try { sv = localStorage.getItem('ms:pc') || ''; sf = localStorage.getItem('ms:pcf') || ''; } catch (_) {}
    /* chưa có postcode nhớ → lấy từ địa chỉ mặc định của khách đã đăng nhập (data-zip, chỉ GB), tầng mặc định Ground */
    if (!sv && box.getAttribute('data-zip')) { sv = box.getAttribute('data-zip'); if (!FLOORS[sf]) sf = '0'; }
    if (sv) { input.value = sv; if (FLOORS[sf]) floor.value = sf; check(sv, sf, true); }
  })();

  /* ── 1f. STICKY ADD-TO-BASKET (mobile; Liquid renders it only for products with the tag in setting sticky_tag) — moved to <body> so no section overflow/transform can clip or re-anchor it; shown once the CTA block has scrolled above the viewport; click = the real ATC button, so Easify validation runs as usual ── */
  (function () {
    var bar = root.querySelector('[data-ms-sticky]'), atc = root.querySelector('.ms-pd__atc'), ctas = root.querySelector('.ms-pdp__ctas');
    if (!bar || !atc || !ctas) return;
    document.body.appendChild(bar);
    var btn = bar.querySelector('[data-ms-sticky-atc]'), price = bar.querySelector('[data-ms-sticky-price]');
    var sym = price.textContent.replace(/[\d.,\s]/g, '') || '£', mq = window.matchMedia('(max-width: 1023px)'), above = false;
    function show() {
      var on = above && mq.matches;
      bar.hidden = !on; btn.disabled = atc.disabled;
      document.body.classList.toggle('has-ms-sticky', on);
      document.documentElement.style.setProperty('--sticky-atc-bar-height', on ? bar.offsetHeight + 'px' : '0px');   /* theme popup tabs sit above it */
    }
    /* scroll + rAF, not IntersectionObserver: a jump that skips the CTA block entirely (tab link, fast fling) never changes its intersection state, so IO never fired */
    var tick = false;
    function onScroll() { if (tick) return; tick = true; requestAnimationFrame(function () { tick = false; above = ctas.getBoundingClientRect().bottom < 0; show(); }); }
    window.addEventListener('scroll', onScroll, { passive: true }); window.addEventListener('resize', onScroll); onScroll();
    if (mq.addEventListener) mq.addEventListener('change', show); else mq.addListener(show);
    btn.addEventListener('click', function () { atc.click(); });
    document.addEventListener('ms:price', function (e) { if (e.detail && isFinite(e.detail.total)) price.textContent = sym + (+e.detail.total).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); });
  })();

  /* ── 2. SKELETON EASIFY ── */
  (function () {
    var ez = root.querySelector('[data-ms-ez]');
    if (!ez) return;
    function loaded() { ez.classList.add('is-loaded'); ez.removeAttribute('aria-busy'); }
    function has() { return ez.querySelector('.po-productPageOptions-root, .po-field-root, [class*="tpo_option"]'); }
    /* sản phẩm không có option set: Easify vẫn dựng [data-tpo-theme] nhưng để rỗng (có option thì ~2–2.4s sau mới vẽ) → chờ 4s rồi ẩn cả slot */
    function empty() { if (!has()) { loaded(); ez.hidden = true; } }
    /* Easify có option set + sp cũng có variant Shopify (cala-tv-unit-150) → Easify là picker chính, ẩn select để khỏi chọn màu 2 lần (select vẫn gửi variant đang chọn) */
    function hideVar() { var c = root.querySelector('[data-ms-var-cfg]'); if (c) c.hidden = true; }
    var emptyT = 0;
    var mo = new MutationObserver(function () {
      if (has()) { ez.hidden = false; loaded(); mo.disconnect(); clearTimeout(emptyT); hideVar(); return; }
      if (!emptyT && ez.querySelector('[data-tpo-theme]')) emptyT = setTimeout(empty, 4000);
    });
    mo.observe(ez, { childList: true, subtree: true });
    if (has()) { loaded(); hideVar(); }
    setTimeout(empty, 10000);
  })();

  /* ── 3. DIALOGS ── */
  (function () {
    root.querySelectorAll('[data-ms-dialog]').forEach(function (b) {
      b.addEventListener('click', function () {
        var d = document.getElementById(b.getAttribute('data-ms-dialog'));
        if (d && d.showModal) d.showModal();
      });
    });
    root.querySelectorAll('dialog.ms-pd__modal').forEach(function (d) {
      d.addEventListener('click', function (e) { if (e.target === d) d.close(); });
      var x = d.querySelector('[data-ms-close]'); if (x) x.addEventListener('click', function () { d.close(); });
    });
  })();

  /* ── 4. FINANCE — V12 (imm.js) inline trong dialog ── */
  (function () {
    var btn = root.querySelector('[data-ms-fin]'), host = document.getElementById('ms-pd-fin-host');
    if (!btn || !host) return;
    var tries = 0, poll = setInterval(function () {
      var p = (typeof promo !== 'undefined' && promo.placements && promo.placements[0]) || null;
      if (!p) { if (++tries > 40) clearInterval(poll); return; }
      clearInterval(poll);
      if (!p.financeIsAvailable()) return;
      var t = btn.querySelector('[data-ms-fin-text]'); if (t) t.textContent = 'Finance from ' + p.minInstalment() + ' a month';
      btn.hidden = false;
      btn.addEventListener('click', function () {
        if (host.querySelector('iframe')) return;
        p.data.modal.position = 'INLINE';
        p.insertElem = '#' + host.id;
        p.createInlineModal();
        var ifr = host.querySelector('iframe'), doc = ifr && ifr.contentDocument;
        if (!doc) return;
        doc.head.insertAdjacentHTML('beforeend', '<style>main{overflow:visible}</style>');
        var dlg = host.closest('dialog'), last = 0;
        var fit = function () { var h = doc.body.scrollHeight; if (h !== last) { last = h; ifr.style.height = h + 'px'; } };
        var arm = function () { var t = setInterval(fit, 250); dlg.addEventListener('close', function () { clearInterval(t); }, { once: true }); };
        arm(); btn.addEventListener('click', arm);
      });
    }, 300);
  })();

  /* ── 5. BADGE SAO (Judge.me, dưới H1) → tab Reviews. Capture + stopPropagation: Judge.me tự cuộn tới widget. ── */
  (function () {
    if (!document.getElementById('ms-tab-rev')) return;
    root.addEventListener('click', function (e) {
      if (!e.target.closest('.jdgm-prev-badge')) return;
      e.preventDefault(); e.stopPropagation();
      selectTab('ms-tab-rev', true);
    }, true);
  })();

  /* ── 8. "View all" versions ── */
  (function () {
    var b = root.querySelector('[data-ms-range]'), g = document.getElementById('ms-pdp-range');
    if (!b || !g) return;
    b.addEventListener('click', function () {
      var open = g.hidden; g.hidden = !open;
      b.setAttribute('aria-expanded', String(open)); b.textContent = open ? 'Hide' : 'View all';
      if (open) window.dispatchEvent(new Event('resize'));   // slider ms-upsell đo lại khi vừa hiện
    });
  })();

  /* ── 9. "N recent views" — Worker msofas-views (đếm thật 14 ngày) + data-offset (200 cho tag giao nhanh, 0 còn lại); 1 lượt/sản phẩm/phiên ── */
  (function () {
    var el = root.querySelector('[data-ms-views]');
    if (!el) return;
    var offset = +el.dataset.offset || 0;
    var key = 'msv:' + el.dataset.pid, seen = false;
    try { seen = sessionStorage.getItem(key) === '1'; } catch (e) {}
    fetch('https://msofas-views.nguyentrunghieu002.workers.dev/hit?p=' + el.dataset.pid + (seen ? '&ro=1' : ''), { method: 'POST' })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(); })
      .then(function (d) {
        try { sessionStorage.setItem(key, '1'); } catch (e) {}
        var n = d.views + offset;
        if (n < 1) return;
        el.querySelector('span').textContent = n.toLocaleString('en-GB');
        el.lastChild.textContent = n === 1 ? ' recent view' : ' recent views';
        el.hidden = false;
      })
      .catch(function () {});
  })();
})();
